import { v4 as uuidv4 } from 'uuid';

/**
 * @typedef {"int" | "si" | "object" | "date" | undefined} SearchConditionType
 */

/**
 * @typedef {object} TypeValue
 * @type {object}
 * @property {Object} id
 * @property {string } label
 */

/**
 * @typedef {object} PropValue
 * @type {object}
 * @property {Object} id - prop id.
 * @property {string} label
 * @property {string} humanReadablePropValue
 * @property {string} operator
 */

/**
 * @typedef {object} PropQuery
 * @type {object}
 * @property {PropValue} prop
 * @property {string | object | undefined} value - value of prop.
 * @property {SearchConditionType} valueType
 * @property {object} data
 */

/** @type {PropValue} */
export class SearchProp {
  prop = undefined;
  value = undefined
  valueType = undefined
  operator = ""
  humanReadablePropValue = ""
  query = {}
  data = {}
  uuid = ""

  constructor() {
    this.uuid = uuidv4()
  }
}

export class SearchCondition {
  /** @type {TypeValue} */
  type = undefined
  /** @type {Array.<SearchProp> | undefined} */
  props = undefined
  uuid = ""
  geoType = 'circle'

  constructor() {
    this.uuid = uuidv4()
    this.type = undefined
    this.props = [/*
      {
        prop: undefined,
        value: undefined,
        valueType: undefined,
        operator: "",
        humanReadablePropValue: "",
        query: {},
        data: {}
      }*/
    ]
  }
}
